import { defineStore } from 'pinia'

export const useTemperatureUnit = defineStore({
  id: 'temperatureUnit',

  state: () => ({
    value: 'F',
  }),

  actions: {
    updateTemperatureUnit(unitName: string) {
      if (unitName === 'celcius') {
        this.value = 'C'
      } else if (unitName === 'fahrenheit') {
        this.value = 'F'
      }
    },
  },

  persistedState: {
    persist: true,
  },
})
